import { Banner, Button, Dialog, Field, Input } from '@cloudflare/kumo';
import { useState } from 'react';
import { PasswordField } from './ui/PasswordField';

interface PerfexSyncModalProps {
  isOpen: boolean;
  onClose: () => void;
  perfexUrl?: string;
  perfexToken?: string;
  onSave: (url: string, token: string) => void;
}

export function PerfexSyncModal({ isOpen, onClose, perfexUrl = '', perfexToken = '', onSave }: PerfexSyncModalProps) {
  const [url, setUrl] = useState(perfexUrl);
  const [token, setToken] = useState(perfexToken);
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      await onSave(url, token);
      onClose();
    } catch (error) {
      console.error('Erro ao salvar:', error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleClose = () => {
    setUrl(perfexUrl);
    setToken(perfexToken);
    onClose();
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={(o: boolean) => { if (!o) (handleClose)(); }}>
<Dialog size="base" className="p-6">


      <h3 className="text-lg font-semibold mb-1">Configurar Perfex CRM</h3>
      <div className="!text-[var(--text-muted)] mb-6">Configure a integração com Perfex CRM</div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <Field label="URL do Perfex CRM" description="URL completa da sua instância Perfex CRM">
          <Input onChange={(e) => setUrl(e.target.value)} placeholder="https://seu-perfex.com" value={url} />
        </Field>

        <PasswordField
          label="Token de API"
          placeholder="••••••••••••••••"
          value={token}
          onChange={setToken}
        />

        <Banner variant="default" description={<>
          Acesse seu Perfex CRM → Configurações → API, gere ou copie seu token.
        </>} />

        <div className="flex gap-3 pt-2 justify-end">
          <Button variant="secondary" type="button" onClick={handleClose}>Cancelar</Button>
          <Button type="submit" variant="primary" disabled={isSaving || !url || !token} loading={isSaving}>
            Salvar Configuração
          </Button>
        </div>
      </form>
    
</Dialog>
</Dialog.Root>
  );
}
